import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
const index = () => import('../pages/index.vue');
const detail = () => import('../pages/detail.vue');
const street = () => import('../pages/street.vue');
const router = new Router({
  // mode: 'history',
  routes: [{
      path: '/',
      component: index,
  },{
    path: '/detail',
    component: detail,
  },{
    path: '/street',
    component: street,
  }]
})
export default router;